
export const GET_SINGLEPOST_REQUEST = "GET_SINGLEPOST_REQUEST";
export const GET_SINGLEPOST_SUCCESS = "GET_SINGLEPOST_SUCCESS";
export const GET_SINGLEPOST_FAILURE = "GET_SINGLEPOST_FAILURE";